// extracted by mini-css-extract-plugin
export default {"highchartsChartContainer":"highcharts-chart-container__highcharts-chart-container__ZVbbs"};